const getCryptoObject = () => {
    if (typeof window !== 'undefined' && window.crypto) {
        return window.crypto;
    }

    throw new Error('Secure random number generator is not available');
};

const guidGenerator = () => {
    const cryptoObject = getCryptoObject();

    if (typeof cryptoObject.randomUUID === 'function') {
        return cryptoObject.randomUUID();
    }

    const randomValues = cryptoObject.getRandomValues(new Uint8Array(16));
    randomValues[6] = (randomValues[6] & 0x0f) | 0x40;
    randomValues[8] = (randomValues[8] & 0x3f) | 0x80;

    const hexValues = Array.from(randomValues, (value) => value.toString(16).padStart(2, '0'));

    return [
        hexValues.slice(0, 4).join(''),
        hexValues.slice(4, 6).join(''),
        hexValues.slice(6, 8).join(''),
        hexValues.slice(8, 10).join(''),
        hexValues.slice(10, 16).join('')
    ].join('-');
}

const getDefaultHeaders = () => {
    return {
            'Schwab-Client-CorrelId': guidGenerator(),
            'Schwab-Client-AppId': "AD00007961",
            'Schwab-Client-Channel': "IO",
            'Schwab-Resource-Version': "1.0"
    }
}

export { guidGenerator, getDefaultHeaders };